import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import { CommentUrl } from './commentUrl';
import { Vote } from './vote';
import { ShareIconBox } from './shareIconBox';
import errorBoundary from '@ifeng/errorBoundary';
import Ppx from '../../../components/ppx';

class ShareBox extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { docData, logoPPX } = this.props;
        const { title, summary, commentUrl, imagesInContent } = docData;

        return (
            <div>
                <ul className={styles.mod_share}>
                    {logoPPX ? (
                        <Chip id="25031" type="static" title="泡泡直播" groupName="头部" user="dev" content={logoPPX}>
                            <Ppx />
                        </Chip>
                    ) : (
                        ''
                    )}
                    <li className={styles.line01} />
                    <CommentUrl docData={docData} />
                    <li className={styles.line01} />
                    <ShareIconBox docData={docData} />
                    <li className={styles.line01} />
                    <Vote docData={docData} url={commentUrl} />
                </ul>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
ShareBox.propTypes = {
    docData: PropTypes.object,
    logoPPX: PropTypes.string,
};

/**
 * 定义组件默认属性
 * */
ShareBox.defaultProps = {};

export { ShareBox };
export default errorBoundary(ShareBox);
